import { _ as __assign } from '../../chunks/bundle-CxLxJCBu.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from '../../chunks/bundle-Dgu8bVmd.js';
import '../../chunks/bundle-CjJk57u5.js';
import '../../chunks/bundle-DS1EhNtb.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-kFa80LJe.js';
import '../../chunks/bundle-DOfhjbKd.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-C_zEpfCP.js';
import '../../chunks/bundle-d1cOX5nv.js';
import '../../chunks/bundle-DKdROCX_.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-CpMvhj21.js';
import '../../chunks/bundle-D2GzZ_yy.js';

var SuggestedMentionList = function (props) {
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props)));
};

export { SuggestedMentionList, SuggestedMentionList as default };
//# sourceMappingURL=SuggestedMentionList.js.map
